import request from '@/utils/request'

// 查询京鲁慧服务类型管理列表
export function listJlhFwlx(query) {
  return request({
    url: '/web/zscq/jlh//fwlxList',
    method: 'get',
    params: query
  })
}

// 查询京鲁慧事项管理表列表
export function listJlhSxgl(query) {
  return request({
    url: '/web/zscq/jlh/sxglList',
    method: 'get',
    params: query
  })
}